<template>
  <div class="card">
    <div class="card-header">
      <!--      <h4 class="card-title pull-left">-->
      <!--        Preset Replies for Outages-->
      <!--      </h4>-->
    </div>
    <div v-if="loading" class="card-body">
      <div class="loader"></div>
    </div>
    <div v-else class="card-body">
      <div class="row">
        <div class="col-md-6">
          <label>Key:</label>
          <input :disabled="editIndex>-1" type="text" class="form-control" required v-model.trim="newMacro.key">
          <label>Friendly Name:</label>
          <input type="text" class="form-control" required v-model.trim="newMacro.name">
<!--          <button class="btn btn-sm btn-primary"  @click="addMacro(' {domain}')">Domain Name</button>-->
<!--          <button class="btn btn-sm btn-primary"  @click="addMacro(' {planName}')">Plan Name</button>-->
<!--          <button class="btn btn-sm btn-primary" @click="addMacro(' {firstName}')">First Name</button>-->
<!--          <button class="btn btn-sm btn-primary" @click="addMacro(' {lastName}')">Last Name</button>-->
<!--          <button class="btn btn-sm btn-primary" @click="addMacro(' {email}')">Email</button>-->
<!--          <button class="btn btn-sm btn-primary" @click="addMacro(' {freeMigrationCount}')">Free Migration Count</button>-->
<!--          <button class="btn btn-sm btn-primary" @click="addMacro(' {boolean}')">Boolean</button>-->
          <br>

          <label>Message:</label>
          <textarea class="form-control" required rows="3" v-model="newMacro.message"></textarea>
          <button v-if="editIndex===-1" @click="submit" class="btn btn-sm btn-primary float-right" type="submit">{{(editIndex === -1) ? 'Submit' : 'Update'}}</button>
          <button v-else @click="updateMacro" class="btn btn-sm btn-primary float-right" type="submit">{{(editIndex === -1) ? 'Submit' : 'Update'}}</button>
        </div>
      </div>
      <section v-if="allPopups.length > 0">
        <hr>
        <div class="row">
          <div class="col-md-8">
            <h5>All Popups</h5>
          </div>
          <div class="col-md-4">
            <button class="btn btn-primary btn-sm pull-right" @click="updateMacro">Update Sorting</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b>Key</b>
          </div><div class="col-md-2">
            <b>Event</b>
          </div>
          <div class="col-md-4">
            <b>Message</b>
          </div>
          <!--                <div class="col-md-2">-->
          <!--                  <b>Status</b>-->
          <!--                </div>-->
          <div class="col-md-2">
            <b>Action</b>
          </div>
        </div>
        <draggable style="height: 700px; overflow: scroll" class="mt-3" v-model="allPopups"  group="people" @start="drag=true" @end="drag=false">
          <div class="row macro" v-for="(macro, index) of allPopups" :key="index">
            <div class="col-md-2">
              <span>{{macro.key}}</span>
            </div><div class="col-md-2">
              <span v-html="(macro.name)? macro.name : ''"></span>
            </div>
            <div class="col-md-4">
              <span v-html="(macro.message) ? macro.message.replace(/\n/g,'<br>') : macro.message.replace(/\n/g,'<br>')"></span>
            </div>
            <!--                  <div class="col-md-2">-->
            <!--                    {{(macro.status) ? macro.status : ''}}-->
            <!--                  </div>-->
            <div class="col-md-4">
<!--              <button class="btn btn-sm btn-danger my-1" ><i class="fa fa-trash"></i></button>-->
              <button class="btn btn-sm btn-primary my-1" @click="editMacro(macro, index)"><i class="fa fa-pencil"></i></button>

            </div>
          </div>
        </draggable>
      </section>
    </div>
  </div>

</template>

<script>
import draggable from "vuedraggable";
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "popups",
  components: {
    draggable,
  },
  props: {
    // presetMacros: {
    //   required: true,
    //   type: Array
    // }
  },
  mounted() {
    this.getPopups()
  },
  data () {
    return {
      newMacro: {
        key: '',
        message: '',
        name: '',
      },
      allPopups: [],
      loading: false,
      editIndex: -1
    }
  },
  methods: {
    async getPopups() {
      try {
        this.allPopups=[]
        this.loading = true
        const ref=await db.collection('popups').get()
        if(ref.size){
          ref.forEach(el => {
            this.allPopups.push({id: el.id, ...el.data()})
          })
        }
        console.log(this.allPopups)
        this.loading = false
      }catch (e) {
        console.log('Unable to get popup list', e.toString())
      }

    },
    addMacro (macro) {
        this.newMacro.message += macro
    },
    // deleteMacro (index) {
    //   this.presetMacros.splice(index, 1)
    //   this.updateMacro()
    // },
    editMacro (macro, index) {
      this.editIndex = index
      this.newMacro=macro
      $('#macrosModal').show().scrollTop(0);
    },
    async submit () {
      try{
        this.loading=true
        await db.collection('popups').add(this.newMacro)
        await this.getPopups()
        swal({
          title: "Success",
          text: 'You have successfully added popup!',
          type: "success",
        });
      }
      catch (e) {
        swal({
          title: "Error",
          text: 'Something went wrong while adding popup!',
          type: "error",
        });
      }finally {
        this.loading=false
        this.newMacro={}
      }
    },
    async updateMacro () {
      try{
        console.log('inside')
        this.loading=true
        await db.collection('popups').doc(this.newMacro.id).update({message: this.newMacro.message, name: this.newMacro.name})
        await this.getPopups()
        swal({
          title: "Success",
          text: 'You have successfully updated popup!',
          type: "success",
        });
      }
      catch (e) {
        swal({
          title: "Error",
          text: 'Something went wrong while updating popup!',
          type: "error",
        });
      }finally {
        this.loading=false
        this.newMacro={}
        this.editIndex=-1
      }
    }
  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
</style>